import { fg } from '@atlaskit/platform-feature-flags/fg';

import { AI_MATE_EXPERIENCE_ID, FEEDBACK_COLLECTOR_ENTRYPOINT_ID } from '../../constants/private';
import { serviceProductToProductKey } from './serviceProductToProductKey';
import type { GlobalConfig, CreateGlobalConfigArgs } from './types';

export const createGlobalConfig = ({
	profileData,
	displaySubmitFlag,
	siteId,
	activationId,
	product,
	experienceId = AI_MATE_EXPERIENCE_ID,
	workspaceId,
	orgId,
	assistanceServiceConfig,
	closeChat,
	emojiProvider,
	preventAbortRequestsOnStagingModalClose,
	preventAbortRequestsOnStandaloneChatClose,
	renderingTouchpoint,
	inProductExperience,
	smartCreationContext,
	jiraIssueCommentEditor,
	autocompletePageContentSource,
	editorContentIdResolver,
	contextualPromptAnalyticsMetadata,
	analyticsProductHeader,
	loadLocalModelAutocomplete,
	requestedSkills,
	creationContextOverrides,
}: CreateGlobalConfigArgs): GlobalConfig => ({
	profileData,
	feedbackCollector: {
		entryPointId: FEEDBACK_COLLECTOR_ENTRYPOINT_ID,
		displaySubmitFlag,
	},
	siteId,
	activationId,
	experienceId,
	workspaceId,
	productKey: serviceProductToProductKey(product),
	productHeader: analyticsProductHeader ?? product,
	orgId,
	assistanceServiceConfig,
	closeChat,
	emojiProvider,
	preventAbortRequestsOnStagingModalClose,
	preventAbortRequestsOnStandaloneChatClose,
	...(fg('fe_enable_sa_externally') && { renderingTouchpoint }),
	inProductExperience,
	smartCreationContext,
	jiraIssueCommentEditor,
	autocompletePageContentSource,
	editorContentIdResolver,
	contextualPromptAnalyticsMetadata,
	analyticsProductHeader,
	loadLocalModelAutocomplete,
	requestedSkills,
	creationContextOverrides,
});
